export const APP_QUERY_PARAMS = {
  CATEGORY: '?category=',
};
